import { useSession } from "@/auth/index";
import { useAppConfigContext } from "@/context/AppConfig";
import { useReportContext } from "@/context/ReportContext";
import { pdfModalsState, usePdf } from "@/reports/index";
import { useState } from "react";

export function useMoreAction(reportPermalink?: string) {
  const { permalink: contextPermalink } = useReportContext();
  const permalink = reportPermalink || contextPermalink;
  const { refetch } = usePdf(permalink, false);
  const { logError } = useAppConfigContext();
  const { session } = useSession();
  const [generatingPdf, setGeneratingPdf] = useState(false);
  const [pdfModalState, setPdfModalState] = useState<pdfModalsState>(
    pdfModalsState.None,
  );

  async function generatePdf() {
    if (
      !session?.account?.account.subscription_info.subscription_features
        .pdf_access
    ) {
      setPdfModalState(pdfModalsState.AddonCheckoutModal);
      return;
    }
    setGeneratingPdf(true);
    const blankWindow = window.open(
      "",
      "_blank",
      "location=yes,height=800,width=600",
    );
    if (!blankWindow) {
      setGeneratingPdf(false);
      const error = new Error("popup_blocked");
      logError("Error generating pdf for report", error);
      return;
    }
    const pdf = await refetch();

    if (blankWindow.location) {
      blankWindow.location = pdf?.data || "";
    }
    setGeneratingPdf(false);
  }

  return {
    generatePdf,
    generatingPdf,
    pdfModalState,
    setPdfModalState,
  };
}
